import React from "react";
import { useParams } from "react-router-dom";
import AudiosPlayScreen from "./AudioPlayScreen";
import AudioEpisodes from "./AudioEpisodes";
import AudioSeriesSlider from "./SimilarAudioEpisodes";
import { useChaptersBySeriesId } from "../../hooks/useChapters";
import Footer from "../../common/UI/Footer";
import Loading from "../../common/HousGlass Loader/Loading"; // Note: There might be a typo in "HousGlass"
import { useAudioBySlug } from "../../hooks/useAudiosHooks";

const AudioPlay = () => {
  const { slug } = useParams();
  
  const {
    data: audioData,
    isLoading,
    error
  } = useAudioBySlug(slug);
  
  // Determine the series ID - either from series_id or from series.id
  const seriesId = audioData?.series_id || audioData?.series?.id;
  
  // Only fetch chapters if we have a series ID
  const {
    series,
    chapters,
    isLoading: isLoadingChapters,
    error: chaptersError,
  } = useChaptersBySeriesId(seriesId); // Provide fallback to prevent undefined

  
  // Handle loading state
  if (isLoading || (seriesId && isLoadingChapters)) {
    return <Loading />;
  }
  
  // Handle errors
  if (error) {
    return <div>Error loading audio: {error.message}</div>;
  }
  
  // Check if seriesId is expected but missing
  if (audioData && !seriesId && audioData.requiresSeries) { // Assuming there's a way to know if series is required
    return <div>Error loading series</div>;
  }
  
  if (seriesId && chaptersError) {
    return <div>Error loading chapters: {chaptersError.message}</div>;
  }

  // Get the series data either from the nested series object or create a simple one from series_id
  const seriesData = audioData?.series || (seriesId ? { id: seriesId } : null);

  return (
    <>
      <AudiosPlayScreen audioData={audioData} series={series} chapters={chapters} />
      
      {/* Only render AudioEpisodes if we have a series ID and chapters */}
      {seriesId && chapters && chapters.length > 0 && (
        <AudioEpisodes
          seriesId={seriesId}
          chapters={chapters}
          seriesData={seriesData}
        />
      )}
      
      {/* Only render AudioSeriesSlider if we have audio data */}
      <AudioSeriesSlider audioData={audioData} />
      
      <Footer />
    </>
  );
};

export default AudioPlay;